// add tab from redux store

import { Dispatch } from "react";
import { uuid } from "uuidv4";
import { TabModel } from "../models/tabModel";
import { AppState } from "../reducers/rootReducer";
import {
  ADD_TAB,
  ADD_TAB_LIST,
  AppActions,
  EDIT_TAB,
  REMOVE_ALL_TABS,
  REMOVE_TAB,
  REMOVE_TAB_LIST_BY_FORM_ID,
  SET_TAB,
} from "../types/actions";
import tabService from "../services/tabService";

export const addTab = (tab: TabModel): AppActions => ({
  type: ADD_TAB,
  tab,
});

export const addTabs = (tabs: TabModel[]): AppActions => ({
  type: ADD_TAB_LIST,
  tabs,
});

export const removeAllTabs = (tabs: TabModel[]): AppActions => ({
  type: REMOVE_ALL_TABS,
  tabs,
});

// remove tab from redux store

export const removeTab = (id: String): AppActions => ({
  type: REMOVE_TAB,
  id,
});

export const removeTabListByFormId = (formId: String): AppActions => ({
  type: REMOVE_TAB_LIST_BY_FORM_ID,
  formId,
});

// edit tab in redux store

export const editTab = (tab: TabModel): AppActions => ({
  type: EDIT_TAB,
  tab,
});

export const setTab = (tabs: TabModel[]): AppActions => ({
  type: SET_TAB,
  tabs,
});

// start adding element to redux store

export const startAddTab = (tabData: {
  elementId: String;
  formId: String;
  name: string;
  properties: any;
  styles: any;
  isDropDownTab: boolean;
  isMain: boolean;
  pairedKey: string;
  tabGroupTitle: string;
  display?: boolean;
  createdTime?: string;
  lastUpdatedTime?: string;
}) => {
  return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    const {
      elementId = "",
      formId = "",
      name = "",
      properties = {},
      styles = {},
      isDropDownTab = false,
      isMain = true,
      pairedKey = "",
      tabGroupTitle = "",
      display = true,
      createdTime = "",
      lastUpdatedTime = "",
    } = tabData;

    const tab = {
      elementId,
      formId,
      name,
      properties,
      styles,
      isDropDownTab,
      isMain,
      pairedKey,
      tabGroupTitle,
      display,
      createdTime,
      lastUpdatedTime,
    };
    const id = uuid();

    const { data } = await tabService.createTab({
      id,
      ...tab,
    });

    dispatch(addTab(data.data));
  };
};

// start editing tab in redux store

export const startEditTab = (tab: TabModel) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    tabService.updateTab(tab);
    dispatch(editTab(tab));
  };
};

// start removing tab in redux store

export const startRemoveTab = (id: String) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(removeTab(id));
  };
};

// start select all tabs in redux store

export const startSetTab = (tabs: TabModel[]) => {
  return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    dispatch(setTab(tabs));
  };
};
